import React, { useState, useEffect } from "react";
import "./style.css";
import { Table, Typography, Collapse, Card  } from "antd";
import moment from "moment";
import Pageloader from "../../../../components/loader";
import { getRiderTasks } from "../../../../services/riders.service";
import { validationErrors } from "../../../../utils/Helpers";

// const { Search } = Input;
// const { Option } = Select;
const { Text } = Typography;
const { Panel } = Collapse;
const pagename = "Orders";

const RiderDetailOrder = (props) => {
  const [postData, setPostData] = useState(null);
  const [postDataPagi, setPostDataPagi] = useState(null);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (props.RiderID){
  //     postLists(1,10);
  //   }
  // }, [props.RiderID]);

  const postLists = async (page=1, limit=10) => {
    let dataFilter = {
      id: props.RiderID,
      page: page,
      limit: limit,
    }
    try {
      setLoading(true);
      const {data} = await getRiderTasks(dataFilter);
      setPostData(data.data);
      setPostDataPagi(data.pagination)
    } catch (e) {
      validationErrors(e);
    } finally {
      setLoading(false);
    }
  };

  const paginationChange = async (page, limit) => {
    postLists(page, limit);
  };


  // const [filter, setFilter] = useState("");
  // const setFiltervalue = (value) => {
  //   setFilter(value);
  // };
  // const [search, setSearch] = useState("");
  // const searchkeys = ["display_id", "t_riderId", "fullName", "phoneNumber"];
  // const globalSearch = (postData) => {
  //   if (search.length == 0) {
  //     return postData;
  //   } else if (search != "" && filter == "display_id") {
  //     return postData.filter((item) =>
  //       item.display_id.toString().toLowerCase().includes(search)
  //     );
  //   } else if (search != "" && filter == "t_riderId") {
  //     return postData.filter(
  //       (item) =>
  //         typeof item.t_riderId === "string" &&
  //         item.t_riderId.toLowerCase().includes(search)
  //     );
  //   } else if (search != "" && filter == "fullName") {
  //     return postData.filter((item) =>
  //       item.fullName.toLowerCase().includes(search)
  //     );
  //   } else if (search != "" && filter == "phoneNumber") {
  //     return postData.filter((item) =>
  //       item.phoneNumber.toLowerCase().includes(search)
  //     );
  //   }
  //   else {
  //     return postData.filter((item) =>
  //       searchkeys.some(
  //         (key) =>
  //           typeof item[key] === "string" &&
  //           item[key].toLowerCase().includes(search)
  //       )
  //     );
  //   }
  // };

  const postColumns = [
    {
      title: "Order ID",
      dataIndex: "_id",
      render: (value) => (value ? value : "-"),
    },
    {
      title: "Customer name",
      dataIndex: "order_detail",
      render: (value) => (value && value.delivery  ? value.delivery.name : ""),
    },
    {
      title: "Customer number",
      dataIndex: "order_detail",
      render: (value) => (value && value.delivery  ? value.delivery.phone : ""),
    },
    {
      title: "Pickup time",
      dataIndex: "status_pickup",
      render: (value) => {return value ? moment(value.createdAt).format("DD MMMM, yyyy, h:mm:ss A"):""},
    },
    {
      title: "Delivered time",
      dataIndex: "status_delivery",
      render: (value) => {return value ? moment(value.createdAt).format("DD MMMM, yyyy, h:mm:ss A"):""},
    },
    {
      title: "Order amount",
      dataIndex: "order_detail",
      render: (value) => {return value ? <Text>Rs. {value.total_amount}</Text> : ""}
    },
    {
      title: "COD",
      dataIndex: "order_detail",
      render: (value) => (value && value?.payment_type && value?.payment_type?.slug === "cod" ? "Yes" : "No"),
    },
    {
      title: "Online paid",
      dataIndex: "order_detail",
      render: (value) => (value && value?.payment_type && value?.payment_type?.slug === "cod" ? "No" : "Yes"),
    },
    {
      title: "Status",
      render: (value) => (value?.status_pickup?.slug !== "completed" ? value?.status_pickup?.title : value?.status_delivery?.title),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (value) => {return value ? moment(value).format("DD MMMM, yyyy, h:mm:ss A"):""},
    },
  ];

  // console.log("data", postData)

  // postLists(1,10)
  
  return (
    <Card title={pagename} bordered>
      <Collapse onChange={postData===null?()=>postLists(1,10):()=>{}}>
        <Panel header={pagename}>
          {loading ? <Pageloader/>:
          <Table
            dataSource={postData}
            columns={postColumns}
            onRow={(r)=>({onDoubleClick:()=>window.open(`/overview/${r._id}`)})}
            pagination={{
              total: postDataPagi?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: postDataPagi?.limit,
              defaultCurrent: postDataPagi?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (currentPage, pageSize) => {
                paginationChange(currentPage, pageSize);
              },
            }}
          />
          }
        </Panel>
        </Collapse>
    </Card>
  );
};

export default RiderDetailOrder;
